import {Component} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {RoutesService} from '../services/routes';
import {UtilsService} from '../services/utils';
import {TrackerService} from '../services/tracker';
import {MenuService} from '../services/menu';
import {SearchService} from '../services/search';
import {PlatformService} from '../services/platform.service';

declare let window:any;

@Component({
    selector: 'gallery',
    templateUrl: '../views/gallery/main.pug',
    styles: [`
      virtual-scroller {
        height: 1500px;
      }
    `],
})
export class GalleryComponent {
  title:string;
  subtitle:string;
  intro:string;
  leafChoice:any;
  boxes:any[];
  sortOptions:string[]=['Default', 'Name'];
  suggestion:string;
  suggestSuccess:boolean;
  activeTag:string;
  centerIcons:boolean;

  subscriptions:any[] = [];

  constructor(
        public platformService:PlatformService,
        private route:ActivatedRoute,
        private router:Router,
        private routes:RoutesService,
        private search:SearchService,
        private menu:MenuService,
        private utils:UtilsService,
        private tracker:TrackerService) {
    window.galleryComponent = this;
    this.setBoxes(this.menu.items);
    this.subscriptions.push(this.menu.choose.subscribe(choice => {
      this.leafChoice = null;
      if (!choice) {
        this.setBoxes(this.menu.items);
        this.subtitle = '';
      } else {
        this.subtitle = choice.title;
        if (choice.children) {
          this.setBoxes(choice.children);
        } else if (choice.link) {
          this.routes.navigate(choice.link);
        } else if (choice) {
          this.leafChoice = choice;
        }
      }
    }))
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngOnInit() {
    this.subscriptions.push(this.route.params.subscribe(params => {
      if (!params['item0']) {
        this.menu.clearSelection();
        this.leafChoice = null;
        this.setBoxes(this.menu.items);
      }
    }));
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      this.search.query = params['query'];
      this.activeTag = params['tag'] || null;
    }));

    let route = this.routes.getCurrentRoute();
    this.title = route.title;
    this.intro = route.intro;
    this.centerIcons = route.icons === 'offset' ? false : true;
  }

  setBoxes(nav) {
    this.boxes = nav;
  }

  isImage(str) {
    return !str.match(/^[a-z\-]+$/);
  }

  marked(str) {
    return window.marked(str);
  }

  sendSuggestion() {
    this.tracker.track('suggestion', {
      text: this.suggestion,
    })
    this.suggestSuccess = true;
    setTimeout(() => {
      this.suggestSuccess = false;
    }, 2000)
  }
}



// WEBPACK FOOTER //
// ./src/app/components/gallery.ts